export const ACL_COMPANY_PRINCIPAL = 'company' as const;

export const ACL_PRINCIPAL_LIMITS = {
  maxEntries: 512,
  maxLength: 256,
} as const;

export function canonicalizeAclPrincipals(principals: readonly string[]): string[] {
  return [...new Set(principals)].sort((left, right) => {
    if (left === right) return 0;
    return left < right ? -1 : 1;
  });
}

export function entraUserPrincipal(oid: string): string {
  return `entra:u:${oid.toLowerCase()}`;
}

export function entraGroupPrincipal(groupId: string): string {
  return `entra:g:${groupId.toLowerCase()}`;
}

export function sharePointSiteGroupPrincipal(siteId: string, groupId: number): string {
  return `sp:sg:${siteId.toLowerCase()}#${groupId}`;
}
